import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React, { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { scrollToTopFunc } from "@components/common/ScrollToTop";
import { PATHS } from "@config";
import { checkPathsList } from "@config/pathsList";
import queryClient from "@config/queryClient";
import { QUERY_KEY } from "@config/queryKeys";
import { showJobs } from "@redux/jobs/actions";
import { checkExistPage } from "@utils/checkFunc";

const Header = ({ staffDetail }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { isAuth } = useSelector((state) => state.auth);
  const dispatchHiddenJobs = useCallback(() => dispatch(showJobs({ hasShow: false })), []);

  const pathNameCustom = id ? pathname.substring(0, pathname.lastIndexOf("/")) : pathname;

  const redirectHome = () => {
    navigate(PATHS.HOME);
    scrollToTopFunc();
    dispatchHiddenJobs();
    queryClient.setQueryData([QUERY_KEY.JOBS], null);
  };

  return (
    <AppBar
      position="static"
      color="default"
      className="jvs-bg-blue position-fixed jvs-t jvs-l"
      style={{
        visibility: checkExistPage(checkPathsList.listPageHideHeader, pathname)
          ? "hidden"
          : "visible",
      }}
    >
      <Toolbar className="d-flex justify-content-between jvs-header align-items-center jvs-p-cont pb-1">
        <Box onClick={redirectHome}>
          <Typography color="white" sx={{ fontSize: "12px !important" }}>
            バイトするなら【エントリー】
          </Typography>
          <Box sx={{ display: "flex" }}>
            <Box
              component="img"
              sx={{
                width: 40,
                height: 40,
              }}
              alt="logo image"
              src="/img/logo-entry.png"
            />
            <Box
              component="img"
              sx={{
                width: 165,
                height: 40,
                ml: -2,
              }}
              alt="logo text"
              src="/img/logo-text.png"
            />
          </Box>
        </Box>
        <Box sx={{ mb: "4px" }}>
          {!isAuth && checkExistPage(checkPathsList.listPageNoAuthShowButton, pathNameCustom) && (
            <Box className="d-flex">
              <Button
                variant="outlined"
                className="btn jvs-btn-white mr-1"
                onClick={() => navigate(PATHS.REGIST_AGREE1)}
              >
                会員登録
              </Button>
              <Button
                className="btn jvs-btn-orange"
                sx={{ color: "var(--primary-text-color) !important" }}
                onClick={() => navigate(PATHS.LOGIN)}
              >
                ログイン
              </Button>
            </Box>
          )}
          {isAuth && (
            <Box>
              <Typography className="jvs-f14">{staffDetail?.data?.casnavi_id}</Typography>
              <Typography className="jvs-f14">{staffDetail?.data?.staff_name}</Typography>
            </Box>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  staffDetail: PropTypes.objectOf(Object),
};

export default memo(Header);
